export const PINCODE_ERROR_TEXT = "Sorry, we're temporarily unable to deliver here";
